var React = require('react');

function CalendarIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.6572 8.82849L7.82868 1.99995L1.00013 8.82849","stroke":"#212C04","strokeWidth":"2","strokeLinecap":"round"}));
}

CalendarIcon.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10","fill":"none"};

module.exports = CalendarIcon;

CalendarIcon.default = CalendarIcon;
